'use client'
import { logger } from '@/lib/logger'
import dynamic from 'next/dynamic'

const LookbackPageClient = dynamic(
  () => import('./lookback-page-client').then((m) => m.LookbackPageClient),
  { ssr: false }
)

export default function Lookback2025Page() {
  try {
    // Note: This is a server component, but LookbackPageClient runs client-side with ssr: false
    // eslint-disable-next-line react-hooks/error-boundaries -- pre-existing: this try/catch doesn't actually catch LookbackPageClient's render errors (JSX creation doesn't invoke the component); a real fix needs a class-based error boundary, left out of scope here to avoid changing behavior
    return <LookbackPageClient />
  } catch (error) {
    logger.error(
      '[Lookback2025Page Error]',
      error instanceof Error ? error : new Error(String(error)),
      {
        context: { error },
        tags: {
          feature: 'lookback-2025',
          error_type: 'page_render_error',
        },
      }
    )
    throw error
  }
}
